import {
    requestMethodTypes,
    requestHeaderNames,
    requestHeaderValue,
} from '../Constants/api.constants';

const playbackRequest = (
    requestData = {},
) => {
    const {
        AUTHORIZATION,
        CONTENT_TYPE,
    } = requestHeaderNames;
    const {
        CONTENT_TYPE_JSON,
        BEARER,
    } = requestHeaderValue;

    const method = requestMethodTypes.GET;
    const headers = {
        [CONTENT_TYPE]: CONTENT_TYPE_JSON,
        [AUTHORIZATION]: `${BEARER} ${requestData.authToken}`,
    };
    const params = {
        AssetId: requestData.assetId,
        PlayerId: requestData.playerId || 'test',
        Platform: requestData.platform || 'web',
        Format: requestData.assetFormat || 'MPEG-DASH',
        LanguageCode: requestData.language || 'en',
        Model: null,
        Secure: 'true',
        Latitude: null,
        Longitude: null,
        Manufacturer: null,
        PlayReadyInitiator: 'true',
    };

    const request = {
        method,
        headers,
        params,
    };

    return request;
};

export {
    playbackRequest as default,
};
